import moment from 'moment';
import {mapGetters, mapActions, mapMutations} from 'vuex';

// Constants
import * as FCFS from '@/store/constants/fcfs';
import * as USER from '@/store/constants/user';

// Modals
import QueueFormModal from './../Modal/QueueFormModal';

// Filters
import AppointmentStatusFilter from '@/views/Common/Filter/AppointmentStatusFilter';
import AppointmentDoctorFilter from '@/views/Common/Filter/AppointmentDoctorFilter';

// Mixins
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';

// Common
import ListWithSpinner from '@/components/ListWithSpinner';
import SearchInput from '@/components/SearchInput';

export default {
  data() {
    return {
      showConfirm: false,
      toBeDeleted: null,
      fields: {
        doctor: [
          {
            key: 'priority', sortable: true
          },
          {
            key: 'patient',
            sortable: true
          },
          'notes',
          {
            key: 'status',
            sortable: true
          },
          'created_at',
          'action'
        ],
        staff: [
          {
            key: 'priority',
            sortable: true
          },
          {
            key: 'patient',
            sortable: true
          },
          {
            key: 'doctor',
            sortable: true
          },
          'notes',
          {
            key: 'status',
            sortable: true
          },
          'action'
        ]
      },
      actions: {
        serving: ['complete', 'delete'],
        awaiting: ['complete', 'serving', 'delete'],
        complete: []
      },
      selected_patient: {},
      isProcessing: false,
      status_variants: {
        complete: 'success',
        service: 'primary',
        pending: 'secondary',
        delete: 'danger'
      }
    }
  },
  components: {
    QueueFormModal,
    AppointmentStatusFilter,
    AppointmentDoctorFilter,
    SearchInput,
    ListWithSpinner
  },
  mixins: [WithDateFilters, WithFilters],
  computed: {
    ...mapGetters({
      queues: FCFS.GET_QUEUE_LIST,
      user: USER.GET_USER
    }),

    isDoctor() {
      return this.user.role.name === 'doctor';
    },

    currentDate() {
      return moment().format('MMMM Do YYYY, h:mm:ss a');
    },

    serving() {
      return window._.head(window._.filter(this.queues.data, (item) => {
        return item.status === 'serving';
      })) || {};
    }
  },

  methods: {
    ...mapActions({
      getQueueList: FCFS.ACTION_LIST_QUEUE,
      updateQueue: FCFS.ACTION_UPDATE_QUEUE,
      deleteQueue: FCFS.ACTION_DELETE_QUEUE
    }),

    ...mapMutations({
      updateListItem: FCFS.MUTATE_UPDATE_QUEUE_ITEM,
    }),

    getFullName(item) {
      return (item) ? `${item.first_name} ${item.last_name}` : null;
    },

    getItemActions(status) {
      return this.actions[status];
    },

    noActionRequired(status) {
      return status === 'complete';
    },

    handleDelete() {
      console.log(this.toBeDeleted, 'dd');
      this.deleteQueue({id: this.toBeDeleted, props: {status: 'delete'}});
      this.updateListItem({id: this.toBeDeleted, props: {status: 'delete'}});
      this.toBeDeleted = null;
      this.showConfirm = false;
    },

    /**
     * Handle row action.
     *
     * @param status
     * @param item
     */
    handleRowAction(status, item) {
      if (status === 'delete') {
        this.showConfirm = true;
        this.toBeDeleted = item.id;
      } else {
        this.updateQueue({id: item.id, payload: {status}});
        this.updateListItem({id: item.id, props: {status}});
      }
    },

    viewDetail(item) {
      this.selected_patient = item.patient;
      this.$router.push({
        name: 'FCFSDetail', params: {id: item.id}
      });
    },

    handleStatusFilter(status) {
      (status !== 'All Status') ? this.setFilter({status: [`status,=,${status}`]}) : this.removeFilter('status');
      this.refreshData();
    },

    handleDoctorFilter(doctor) {
      (doctor.value !== 0) ? this.setFilter({doctor: [`doctor_id,=,${doctor.value}`]}) : this.removeFilter('doctor');
      this.refreshData();
    },

    /**
     * Refresh the table list.
     */
    refreshData() {
      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, ...{wildcard: this.wildcard}};
      }

      filters = {...filters, ...{page: this.queues.current_page, order_by: ['doctor_id,desc']}};

      this.isProcessing = true;

      this.getQueueList(filters).finally(() => this.isProcessing = false);
    },

    /**
     * Filter
     */
    filterPatient: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`patient_first_name|patient_last_name,like,${item}`] : null;
      this.refreshData();
    }, 300),

    /**
     * Get row variant
     *
     * @param status
     * @returns {string}
     */
    getStatusColor(status) {
      return this.status_variants[status];
    },

    /**
     * Get appointments by role.
     *
     * @param user
     */
    getAppointmentsByRole(user) {
      this.setDateFilterKeyField('appointment_date');
      this.initializeDateFilter();
      (user.role.name === 'doctor')
        ? this.handleDoctorFilter({value: user.doctor.id})
        : this.refreshData();
    },

    handlePaginate() {
      this.refreshData();
    },

    showModal() {
      this.$root.$emit('bv::show::modal', 'addToQueueModal', '#addToQueueModal')
    }
  },

  created() {
    this.getAppointmentsByRole(this.user);

    if (this.$route.query.add) {
      this.$nextTick(function () {
        this.showModal();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/FCFS/js/fcfs-list.js